'use strict';

import React, { Component } from 'react'

import { handleChange } from '@/Form/Functions/eventsHandling'

import FormElement from '@/Form/toolkit/FormElement'

let app = window.app;

const moment = window.moment;

export default class AbondementDownload extends Component
{
	state =
	{
		loading: false,

		form_data:
		{
			start: moment().startOf('year').format('YYYY-MM-DD'),
			end: moment().endOf('year').format('YYYY-MM-DD')
		}
	};

	handleChange = handleChange.bind(this);

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const form_data = state.form_data;

		let link = '/export/abondement-des-membres?start=' + form_data.start +
			'&end=' + form_data.end;

		let output =
		(
			<div className="c-abondement-export">

				<div className="c-title c-title--v2">
					<div className="c-title__txt">
						Export de l'abondement par utilisateur
					</div>
				</div>

				<div className="c-abondement-export__content">

					<FormElement name="start" label="Début"
						type="date" data={ state.form_data }
						onChange={ component.handleChange }
						status={ state.status_messages }
					/>

					<FormElement name="end" label="Fin"
						type="date" data={ state.form_data }
						onChange={ component.handleChange }
						status={ state.status_messages }
					/>

					<a type="button" href={ link } target="_blank"
						rel="noopener noreferrer"
						className="c-btn c-btn--extra u-margin-left-10">
						Exporter
					</a>

				</div>

			</div>
		);

		return output;
	}
}